<template>
  <v-row>
    <v-col cols="12">
      <v-dialog v-model="dialog" persistent max-width="60%">
        <v-card>
          <!-- <v-form ref="form" lazy-validation> -->
          <v-card-title>
            <span>Details</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" class="mt-0 pt-0">
                  <table class="retailer-details">
                    <tr>
                      <td class="w-40">Name:</td>
                      <td>{{ data.firstName }}</td>
                    </tr>
                    <tr>
                      <td>Mobile Number:</td>
                      <td>{{ data.mobileNumber }}</td>
                    </tr>
                    <tr>
                      <td>City:</td>
                      <td>{{ data.city }}</td>
                    </tr>
                    <tr>
                      <td>Region:</td>
                      <td>{{ data.region }}</td>
                    </tr>
                  </table>
                </v-col>
                <v-col cols="12">
                  <v-btn color="primary" class="ml-auto">
                    <download-csv :data="exportData" :name="`${fileName}.csv`">
                      <v-icon dense>mdi-download</v-icon>
                      Export
                    </download-csv>
                  </v-btn>
                </v-col>
                <v-col cols="12" class="mt-0 pt-0">
                  <v-data-table
                    :headers="table.headers"
                    :items="table.data"
                    :items-per-page="10"
                    :loading="table.loading"
                    item-key="id"
                    :search="search"
                    loading-text="Loading... Please wait"
                    class="elevation-1"
                  >
                    <template v-slot:[`item.amount`]="{ item }">
                      {{ item.amount.toLocaleString() }}
                    </template>

                    <template v-slot:[`item.name`]="{ item }">
                      {{ item.name ? item.name : "-" }}
                    </template>
                    <template
                      v-for="header in table.headers.filter((header) =>
                        header.hasOwnProperty('formatter')
                      )"
                      v-slot:[`item.${header.value}`]="{ value }"
                    >
                      {{ header.formatter(value) }}
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="pb-5">
            <v-spacer></v-spacer>
            <v-btn :disabled="loadingBtn" @click="closeDialog()">
              Close
            </v-btn>
            <!-- <v-btn
                color="primary"
                :loading="loadingBtn"
                :disabled="loadingBtn"
                @click="onSubmit()"
                class="px-10"
              >
                Save
              </v-btn> -->
          </v-card-actions>
          <!-- </v-form> -->
        </v-card>
      </v-dialog>
      <!-- <Snackbar></Snackbar> -->
    </v-col>
  </v-row>
</template>

<script>
// import Snackbar from "../Snackbar.vue";
import moment from "moment";
export default {
  name: "RetailerDetailsDialog",
  components: {
    // Snackbar,
  },
  props: ["dialog", "data", "reportName"],
  data() {
    return {
      exportData: [],
      fileName: "",

      loadingBtn: false,
      rules: {
        required: [(value) => !!value || "Required."],
      },

      search: "",
      table: {
        // sortBy: "dtCreated",
        sortDesc: true,
        loading: false,
        // activationDate: (...)
        // amount: (...)
        // incentive: (...)
        // loadDate: (...)
        // monthsaryDate: (...)
        // name: (...)
        headers: [
          {
            text: "Activation Date",
            align: "start",
            sortable: true,
            value: "activationDate",
            formatter: (x) => (x ? moment(x).format("MMM DD, YYYY") : null),
          },
          {
            text: "Name",
            align: "start",
            value: "name",
          },

          {
            text: "Load Date",
            align: "start",
            sortable: false,
            value: "loadDate",
            formatter: (x) => (x ? moment(x).format("MMM DD, YYYY") : null),
          },
          {
            text: "Amount",
            align: "center",
            value: "amount",
            formatter: (x) => (x ? x.toLocaleString() : 0),
          },

          {
            text: "Incentive",
            align: "center",
            value: "incentive",
            formatter: (x) => (x ? x.toLocaleString() : 0),
          },

          {
            text: "Monthsary Date",
            align: "start",
            sortable: true,
            value: "monthsaryDate",
            formatter: (x) => (x ? moment(x).format("MMM DD, YYYY") : null),
          },
        ],
        data: [],
      },
    };
  },
  methods: {
    async getList(data) {
      // subscriber-transactions
      this.table.loading = true;
      await this.$api
        .get(
          `acquisition/report?report=dealer-commision-report&dealerId=${data.dealerId}`
        )
        .then((response) => {
          // console.log(response);
          const newArr = response.data.data.subscribers;
          console.log("report", response);
          this.table.data = newArr;

          let exportData = newArr.map((item) => {
            return {
              "Activation Date": moment(item.activationDate).format(
                "MMM DD, YYYY"
              ),
              Name: item.name,
              "Load Date": moment(item.loadDate).format("MMM DD, YYYY"),
              Amount: item.amount,
              Incentive: item.incentive,
              "Monthsary Date": item.monthsaryDate,
            };
          });
          this.fileName = `${data.firstName}_${data.lastName}_reports`;
          this.exportData = exportData;
          // console.log();

          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    closeDialog() {
      this.$emit("close", false);
      // this.$refs.form.reset();
    },
  },

  created() {},

  watch: {
    dialog(val) {
      if (val) {
        this.getList(this.$props.data);
      }
    },
  },

  computed: {},
};
</script>

<style scoped>
table.retailer-details {
  width: 100%;
  border-collapse: collapse;
  /* border: 1px solid #e2e2e2; */
  text-align: left;
}

table.retailer-details tr,
td,
th {
  padding: 10px 10px;
  border: 1px solid #e2e2e2;
}

.w-40 {
  width: 40%;
}
</style>
